<button (click)="openExportModal()" [disabled]="!path || disabled"
        class="btn export-link TableFooter__BtnExportCSV">
  <img src="assets/images/export.svg" alt="">
  <span>{{ 'common.exportCsv' | translate }}</span>
</button>
<maalchat-crm-export-csv-modal [path]="path" [params]="params" #exportCSV></maalchat-crm-export-csv-modal>
